import { useScreenShare } from '@daily-co/daily-react';
import { getCaptureStream, setCaptureStream } from '../shared/captureStream';

export const useScreenSharing = () => {
  const { isSharingScreen, startScreenShare, stopScreenShare } = useScreenShare();

  const assignCaptureScreen = async () => {
    const currentCaptureStream = getCaptureStream();

    if (currentCaptureStream && currentCaptureStream.active) {
      return currentCaptureStream;
    }

    const captureStream = await navigator.mediaDevices.getDisplayMedia({ video: true });
    setCaptureStream(captureStream);

    return captureStream;
  };

  const stopScreenSharing = () => {
    const captureStream = getCaptureStream();

    stopScreenShare();
    captureStream?.getTracks()?.[0].stop();
    setCaptureStream(undefined);
  };

  const handleScreenShare = async ({ stop }: { stop: boolean }) => {
    let captureStream;

    if (stop) {
      stopScreenSharing();
      return;
    }

    if (isSharingScreen) {
      stopScreenSharing();
    }

    try {
      captureStream = await assignCaptureScreen();
    } catch (err) {
      console.error(`Failed to get display media: ${err}`);
    }

    if (captureStream) {
      startScreenShare({ mediaStream: captureStream });
    }
  };

  const displaySurface = (getCaptureStream()?.getTracks()?.[0].getSettings()?.displaySurface ||
    'unknown') as DisplayCaptureSurfaceType | 'unknown';

  return {
    isSharingScreen,
    sharedSurface: displaySurface,
    stopScreenSharing,
    handleScreenShare,
  };
};
